import { render, staticRenderFns } from "./compClubMT.vue?vue&type=template&id=3a489dba"
import script from "./compClubMT.vue?vue&type=script&lang=js"
export * from "./compClubMT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports